/**
 * Naming convention:
 * {category, ui element}_{what_it_does}_{what_it_does}
 *
 * examples:
 * icon_youtube
 * language_selector_dropdown_label
 * color_theme_brown_dark
 * background_color_brown_dark
 * text_color_brown_dark
 */
export interface EmbeddableMarkup {
  scripts?: string[];
  externalScriptSources?: string[];
  html: string;
}

export type ShortCodesMap = {
  EMBEDS: Record<string, EmbeddableMarkup>;
  [key: string]: Record<string, string> | Record<string, EmbeddableMarkup>;
};

export const SHORT_CODES_MAP: ShortCodesMap = {
  icons: {
    icon_facebook: "icon_facebook",
    icon_instagram: "icon_instagram",
    icon_youtube: "icon_youtube",
    icon_twitter: "icon_twitter",
    icon_linkedin: "icon_linkedin",
  },
  // shortCocdes defined in EMBEDS will _replace_ the content of a module with injected html !
  EMBEDS: {
    embed_activecampaign: {
      externalScriptSources: [
        "https://carlsberg8779.activehosted.com/f/embed.php?id=1",
      ],
      html: `<div class="_form_1"></div>`,
    },
    embed_brave: {
      externalScriptSources: ["https://hoc.bravespark.com/app.min.js"],
      html: `<div id="brave-container"></div>`,
    },
  },
};
